import React from 'react';

import { LoginForm } from '../../components';
import './sign-in-form.scss';

export const SignInPage = () => {
  return (
    <main className='sign-in-page'>
      <div className='sign-in-shell'>
        <section className='sign-in-story' aria-label='Vicem Bỉm Sơn'>
          <img className='sign-in-story-logo' src='/logo-vicem-bim-son.png' alt='Vicem Bỉm Sơn' width='210' height='64' />

          <svg className='sign-in-factory' viewBox='0 0 520 220' fill='none' aria-hidden='true' focusable='false'>
            <circle cx='403' cy='60' r='38' fill='currentColor' opacity='.06' />
            <g stroke='currentColor' strokeWidth='1.5' strokeLinejoin='round'>
              <path d='M20 192h480M48 192v-62l68-32v32l68-32v94M48 130h136M64 151h20v23H64zM98 151h20v23H98zM132 151h20v23h-20z' />
              <path d='M196 192V82h49v110M190 82h61l-9-17h-43l-9 17ZM211 65V42h19v23M260 192V82h49v110M254 82h61l-9-17h-43l-9 17ZM275 65V42h19v23M245 114h15M245 148h15' />
              <path d='M325 192v-45l41-23 40 23v45M325 147h81M345 192v-27h41v27M423 192V90h25v102M418 90h35M429 90V34h13v56M448 129h29v63M184 171h12M309 171h16' />
              <path d='M220 42V29M284 42V23M435 34V17' strokeDasharray='3 6' opacity='.5' />
              <path d='M36 204h448' opacity='.3' />
            </g>
            <path d='M66 191h88M212 191h18M276 191h18M346 191h39' stroke='#ed6d64' strokeWidth='3' />
          </svg>
        </section>

        <section className='sign-in-access' aria-labelledby='sign-in-title'>
          <div className='sign-in-welcome'>
            <h1 id='sign-in-title'>Đăng nhập</h1>
            <p>Sử dụng tài khoản được cấp để truy cập hệ thống.</p>
          </div>
          <LoginForm />
          <div className='sign-in-help'>
            <span className='dx-icon dx-icon-info' aria-hidden='true' />
            <p>Cần hỗ trợ tài khoản?<br />Liên hệ bộ phận Công nghệ thông tin.</p>
          </div>
        </section>
      </div>

    </main>
  );
};
